import { Alert, Button, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { STATE } from "../../theme/mantine-theme";

/**
 * Something failed. Say WHAT happened and WHAT TO DO.
 *
 * Not "an error occurred". The API client already distinguishes a lost
 * connection from a refusal, and those need different words from the reader:
 * one is "check your signal", the other is "this is not allowed".
 */
export function ErrorState({
  title = "That did not work",
  message,
  onRetry,
  retryLabel = "Try again",
}: {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  return (
    <Alert
      variant="light"
      color="red"
      radius="md"
      title={title}
      styles={{ root: { backgroundColor: STATE.overdue.bg } }}
    >
      <Stack gap="sm" align="flex-start">
        <Text fz="md" c="gray.8">
          {message}
        </Text>
        {onRetry && (
          <Button size="sm" variant="default" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </Stack>
    </Alert>
  );
}

/** The same, inline under a field. No title, no retry - just what is wrong. */
export function InlineError({ children }: { children: ReactNode }) {
  return (
    <Text fz="sm" c={STATE.negative.fg} fw={500} mt={4}>
      {children}
    </Text>
  );
}
